module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "type": "info",
      "show-icon": "",
      "title": "Under Development",
      "description": "Still under testing not everything is working yet."
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Revenue")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isManager('finance')) ? _c('site-revenue-add', {
    attrs: {
      "renewals": _vm.renewals,
      "site-id": _vm.site.id
    },
    on: {
      "update": _vm.addRenewal
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('site-revenue-statement', {
    attrs: {
      "renewals": _vm.renewals
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7785b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/revenue/SiteRevenue.vue
// module id = 1448
// module chunks = 0